import React, { useEffect, Fragment, useState } from "react";
import { Modal, Row, Col, Spinner, Form as BSForm } from "react-bootstrap";
import styled from "styled-components";
import {
  CustomControl,
  CustomButton,
  CustomSelect,
  CustomNumberInput,
} from "components/CustomForm";
import { MdClose } from "react-icons/md";
import { useMutation, useQuery } from "react-query";
import { createUnit, updateUnit, getUnits } from "network/apis/InformationApi";
import { toast } from "react-toastify";
import { Field, Form, Formik } from "formik";
import { getErrorMessage } from "helpers/strings";

const ModalHolder = styled(Modal)`
  font-family: "YEKAN-BAKH-MEDIUM";
`;

const Check = styled(BSForm.Check)`
    display: inline;
`;

const Header = styled.div`
  font-size: 18pt;
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

const FormHolder = styled(Form)`
  direction: rtl;
`;

const CloseButton = styled.div`
  background-color: #424250;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  top: 12px;
  right: 10px;
`;

const AddUnitModal = ({ isOpen, onClose, onCreateSuccess, data, ...rest }) => {
  const [isDefault, setIsDefault] = useState(false);
  const [loading, setLoading] = useState(false);

  const isEditMode = () => data && data != null;  

  useEffect(() => {
		if (data && data != null) {
      setIsDefault(data.is_default);
    }
	}, [data]);

  const unitMutation = useMutation(isEditMode() ? updateUnit : createUnit, {
    onSuccess: (res) => {
      if (res && res.data) {
        toast(`با موفقیت ${isEditMode() ? "ویرایش" : "ایجاد"} گردید`, {
          type: "success",
          position: "bottom-right",
        });
        onCreateSuccess?.();
        onClose();
      }
    },
    onError: (err) => {
      toast(getErrorMessage(err), {
        type: "error",
        position: "bottom-right",
      });
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  return (
    <ModalHolder
      show={isOpen}
      size={"lg"}
      centered
      animation={false}
      onHide={onClose}
      {...rest}
    >
      <Modal.Body className="px-5">
        <CloseButton onClick={onClose}>
          <MdClose color="#fff" />
        </CloseButton>
        <Header>
          <span>{isEditMode() ? "ویرایش" : "افزودن"} واحد سنجش</span>
        </Header>
        <Formik
          initialValues={{
            name: data?.name ?? "",
            conversion_to_default_unit: data?.conversion_to_default_unit
          }}
          validate={(values) => {
            const errors = {};
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setLoading(true);
            unitMutation.mutate({
              id: data?.unit_id,
              is_default: isDefault,
              ...values
            });
          }}
        >
          {({ isSubmitting, submitForm }) => (
            <FormHolder>
              <Fragment>
                <div className="d-flex justify-content-between mb-4 w-100">
                  <Col md={6} className="ps-1">
                    <Field type="text" name="name">
                      {({ field, meta: { touched, error } }) => (
                        <CustomControl
                          className={touched && error ? "invalid" : ""}
                          {...field}
                          placeholder="نام واحد سنجش"
                          radius="14"
                        />
                      )}
                    </Field>
                  </Col>
                  <Col md={6} className="pe-1">
                    <Field type="text" name="conversion_to_default_unit">
                      {({ field, meta: { touched, error } }) => (
                        <CustomNumberInput
                          className={touched && error ? "invalid" : ""}
                          {...field}
                          placeholder="نسبت به واحد پیش فرض"
                          radius="14"
                        />
                      )}
                    </Field>
                  </Col>
                </div>
                <div className="d-flex justify-content-start w-100">                  
                    <Check
                      type="checkbox"
                      id='is_default'
                      className='ms-3'
                      onChange={(e) => setIsDefault(e.target.checked)}
                      checked={isDefault}
                    />
                    <label htmlFor='is_default'>
                      {isDefault ? 'پیش فرض' : 'پیش فرض'}
                    </label>                  
                </div>
                <div className="d-flex justify-content-center mt-4 mb-3 w-100">
                  <CustomButton
                    className="ms-3 w-25"
                    color="#7300FF"
                    fontSize={16}
                    onClick={onClose}
                  >
                    انصراف
                  </CustomButton>
                  <CustomButton
                    fontSize={16}
                    onClick={submitForm}
                    disabled={loading}
                    className="w-25 d-flex align-items-center justify-content-center"
                  >
                    {loading ? (
                      <Spinner animation="border" role="status" size="sm" />
                    ) : (
                      <span>ثبت</span>
                    )}
                  </CustomButton>
                </div>
              </Fragment>
            </FormHolder>
          )}
        </Formik>
      </Modal.Body>
    </ModalHolder>
  );
};

export default AddUnitModal;
